export class QueryDBResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryId",
            "baseName": "queryId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryDBResponse.attributeTypeMap;
    }
    constructor() {
    }
}
